import { render, staticRenderFns } from "./PaymentTariffActive.vue?vue&type=template&id=ec39f0ae&scoped=true&"
import script from "./PaymentTariffActive.vue?vue&type=script&lang=js&"
export * from "./PaymentTariffActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec39f0ae",
  null
  
)

export default component.exports